import MDTypography from "components/MDTypography";
import { useNavigate } from "react-router-dom";
import { MenuItem } from "@mui/material";
import moment from "moment";
import { useLanguage } from "contexts/language.context";

export default function NotificationElement({
  notification,
  onRead,
  disabled,
  handleCloseMenu,
}) {
  const { label } = useLanguage();
  const navigate = useNavigate();

  function extractAuditNotification(description) {
    if (!description || typeof description !== "string") return null;

    const patterns = [
      /^The audit <(.+)> was (assigned|submitted|approved|completed|accomplished) by (.+)$/i,
      /^The audit --\s*(.+)\s*-- was (assigned|submitted|approved|completed|accomplished) by (.+)$/i,
      /^The audit "(.+)" was (assigned|submitted|approved|completed|accomplished) by (.+)$/i,
      /^The audit -(.+)- was (assigned|submitted|approved|completed|accomplished) by (.+)$/i,
      /^Audit <(.+)> has been submitted$/i,
      /^Audit --\s*(.+)\s*-- has been submitted$/i,
      /^Audit "(.+)" has been submitted$/i,
    ];

    for (const pattern of patterns) {
      const match = description.match(pattern);
      const auditName = match?.[1]?.trim();

      if (
        auditName &&
        !["null", "undefined"].includes(auditName.toLowerCase())
      ) {
        return {
          auditName,
          action: (match[2] || "submitted").toLowerCase(),
          actorName: match[3]?.trim(),
        };
      }
    }

    return null;
  }

  function getAuditNotificationDescription(description) {
    const exactTranslation = label(description.trim().replaceAll(" ", "-"));

    if (exactTranslation) return exactTranslation;

    const normalizedDescription = description.trim().toLowerCase();

    if (
      normalizedDescription === "a new audit was assigned to you" ||
      normalizedDescription === "a new audit has been assigned to you!"
    ) {
      return label("notification-audit-assigned-message") || description;
    }

    const extracted = extractAuditNotification(description);

    if (!extracted) return description;

    const template =
      label(`notification-audit-${extracted.action}-message`) ||
      label("audit-has-been-submitted");

    if (!template) return description;

    return template
      .replace("<audit.description>", extracted.auditName)
      .replace("<actor.name>", extracted.actorName || "");
  }

  return (
    <MenuItem
      disabled={disabled}
      sx={{
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        borderRadius: 0,
        marginRight: -1,
        marginLeft: -1,
      }}
      onClick={() => {
        navigate(notification.url);
        handleCloseMenu();
        onRead(notification.id);
      }}
    >
      <MDTypography sx={{ fontSize: "1rem" }}>
        {notification.auditId
          ? getAuditNotificationDescription(notification.description)
          : notification.description}
      </MDTypography>
      <MDTypography sx={{ fontSize: "0.8rem", opacity: 0.5 }}>
        {moment(new Date(notification.createdAt)).calendar()}
      </MDTypography>
    </MenuItem>
  );
}
